import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-user-on-pro-license-modal',
    imports: [],
    templateUrl: './user-on-pro-license-modal.component.html',
    styleUrl: './user-on-pro-license-modal.component.scss'
})
export class UserOnProLicenseModalComponent {

  constructor(
    private router: Router
  ){

  }

  public redirectToLicensesPage(){
    this.router.navigate(['/architect/profile/billing'], { queryParams: { tab: 'licence' } });
  }

}
